import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux';
import Popup from '../../../components/modal/popup.jsx'
import WalletTranfer from './WalletTranfer.jsx'
import ReportWraper from './commom/ReportWraper.jsx'
import SearchBox from './commom/SearchBox.jsx'
import AccountCR from './modals/AccountCR.jsx';
import './wallet-management.scss';

class WalletManagement extends Component {

  constructor(){
    super();
    this.state = {
      rebetModal: null,
      accountCRModal: null,
      selfinBalance:null,
      parentids:null,
      type:''
    }
    this.query = {
      orderBy: 'children_num',
      sortBy: 'desc',
      pageNo: 1,
      userId: window.userId,
      username: ''
    }
  }

  componentDidMount(){
    this.props.setQuery(this.query);

    this.props.$$USER.getSaftywalletInfo([],(res)=>{
      this.setState({
        selfinBalance:res.data.usdtavailableBalance,
        parentids:res.data.self.parentid,
      })
      
    })
  }

  componentWillReceiveProps(nextProps){
    if(!_.isEqual(this.props.querys, nextProps.querys)){
      this.search(nextProps.querys)
    }
  }

  search(querys){
    const {pageNo, orderBy, sortBy, userId, username} = querys;
    this.props.$$DASH.getTeamUserList({username, userId, pageNo, orderBy, sortBy});
  }

  setFollwerRebet = ({user, rebet} = {}) => {
    if(_.round(user.userpoint * 100, 1) == rebet){
      return this.props.$$BASE.openToast('当前返点已为：' + rebet + '%');
    }
    this.setState({rebetModal: null});
    this.props.$$DASH.setFollwerRebetNew({userId: user.userid, point: rebet}, (res) => {      
      if (res.status == 10000) {
        return this.props.$$BASE.openToast('您的下级返点已设置为' + rebet + '%')        
      }
    })
  }

  // 下级转帐
  onCanRecharge(item,type) {
    this.setState({
      trans2MemberModal: item,
      type:type
    })
    
  }
  
  
  render() {
    const __dash = this.props.__DASH.toJS();
    const __view = __dash.view;
    const __uses = this.props.__USER.toJS();
    const { info } =__uses;
    const {orderSort, getSortIcon, setQuery, querys} = this.props;
    return (
      <div className="contents-component contents">
        <div className="title-warp">
          <span className="title ref-content-title">钱包管理</span>
        </div>
        <div className='personal-container frame-container'>
            <div className='report-common-container team-management-box'>
            <div className='info'>账户余额:￥{info.safetywalletbalance}</div>
            <div className="report-header">
            <SearchBox text='查询用户名' onChange={_.noop} action={(username) => this.search({...querys, username, userId: '', pageNo: 1})} />
            </div>
            <div className="content-box">
              <div className="summary">
                <i className='self' />本级：&nbsp;
                {
                  _.get(__view, 'bread[0]') && 
                  __view.bread.map((item, index) => 
                    <span key={item.userid} onClick={() => setQuery({userId: item.userid, username: ''})} >
                      {
                        index == 0 && <strong>{_.split(item.username,'@')[0]}</strong>
                      }
                      {
                        index > 0 && <Fragment>&nbsp;&gt;&nbsp;{_.split(item.username,'@')[0]}</Fragment>
                      }
                    </span>  
                  )
                }
                <span className='fr'>注：可点击标题修改排序</span>
              </div>
              <table className='data' width="100%" border="0" cellSpacing="1" cellPadding="0" >
                <tbody>
                  <tr>
                    <th className='pointer' ><span onClick={() => orderSort('username')} className={getSortIcon('username')} >用户名</span></th>
                    <th className='pointer' ><span onClick={() => orderSort('children_num')} className={getSortIcon('children_num')} >人数</span></th>
                    <th className='pointer' ><span onClick={() => orderSort('availablebalance')} className={getSortIcon('availablebalance')}>个人余额</span></th>
                    <th className='pointer' ><span onClick={() => orderSort('lasttime')} className={getSortIcon('lasttime')} >最后登录</span></th>
                    <th>操作</th>
                  </tr>
                  {
                    _.get(__view, 'users[0]') &&
                    <Fragment>
                      {
                        __view.users.map((item) => 
                          <tr key={item.userid}>
                            <td><a onClick={() => setQuery({userId: item.userid, username: ''})} >{item.username}</a></td>
                            <td>{item.children_num}</td>
                            <td>{item.availablebalance}</td>
                            <td>{item.lasttime}</td>                    
                            {
                              item.username == info.username ?
                              <td>
                                <a onClick={() => this.setState({accountCRModal: item})}><strong>账变记录</strong></a>
                                <a onClick={() => this.onCanRecharge(item,'selfin' )} ><strong>转入个人钱包</strong></a>                         
                                <a onClick={() => this.onCanRecharge(item,'selfout' )} ><strong>转出到平台</strong></a>
                                {this.state.parentids !=0 && <a onClick={() => this.onCanRecharge(item,'up')} ><strong>上级转账</strong></a>}
                              </td>
                              :
                              <td>
                                <a onClick={() => this.setState({accountCRModal: item})}><strong>账变记录</strong></a>                         
                                <a onClick={() => this.onCanRecharge(item,'down')} ><strong>下级转账</strong></a>
                              </td>
                            }
                          </tr>  
                        )
                      }
                    </Fragment>
                  }
                </tbody>
              </table>
            </div>
            {
              this.state.trans2MemberModal && 
              <Popup display width={600} height={420} onclose={() => this.setState({trans2MemberModal: null})} >
                <WalletTranfer 
                  user={this.state.trans2MemberModal} 
                  bal={info.safetywalletbalance} 
                  closeModal={() => {this.setState({trans2MemberModal: null}), this.search(querys)}}
                  type={this.state.type}
                  selfinBalance={this.state.selfinBalance} 
                />
              </Popup>
            }
            {
              this.state.accountCRModal && 
              <Popup display width={1040} height={580} onclose={() => this.setState({accountCRModal: null})} >
                <AccountCR userid={this.state.accountCRModal.userid} username={this.state.accountCRModal.username} />
              </Popup>
            }
          </div>
        </div>
      </div>
      
    )
  }
}

function mapStateToProps(state) {
  return {
    __DASH: state.dashboard,
    __USER: state.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    $$DASH: bindActionCreators(dashAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$USER: bindActionCreators(userAction, dispatch),
    $$REPORT:bindActionCreators(reportAction, dispatch),
  };
}

var WalletManagementConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(WalletManagement);

export default ReportWraper(WalletManagementConnect);